/* eslint-disable valtio/state-snapshot-rule */
import { useSnapshot } from 'valtio';
import { tasksState } from '../state';
import { ITask } from '../types';
import { useMemo } from 'react';

function useTasks() {
  const { tasks } = useSnapshot(tasksState);

  const taskArray = useMemo(() => Object.values(tasks) as ITask[], [tasks]);

  return {
    tasks: taskArray,
    taskById: tasks,
  };
}

export default useTasks;
